module.exports = __webpack_public_path__ + "static/media/search.03b5ad95.svg";